import React from 'react'

import DinamicCrudCustomConsulta from '../../../DinamicForms/components/DinamicCrudCustomConsulta';
import { Item, DinamicComponents } from 'scorpion-core';

import EditorCodigo from '../../editor/EditorCodigo'
function componentRelEspelho(comp, dados) {
    return ""

}


function component(item, propsG) {
    return <Item />
}

const modelo = {
    typeComponente: "ConsultaPersonalisada",
    label: "ConsultaPersonalisada",
    editarEmDialog: false,
    botoesAntes: false,
    colunas: ["sequencialIndex", "titulo"],
    filtros: [],
    descricaoFiltroCodigo: '',
    filtroCodigo: `function filtrarLista(lista) {    
        return lista;
    }`,
}

const comp = {
    typeComponente: "ConsultaPersonalisada",
    configView: {
        nome: "Consulta Personalisada",
        modelo,
        editores: {
            colunas: DinamicComponents.EditorLista,
            filtros: DinamicComponents.EditorLista,
            filtroCodigo: EditorCodigo,
        },
    },
    componentRelEspelho,
    component,

    geraSubConfig: (form, c) => {
        let funcFiltroLista = null;
        if (c.descricaoFiltroCodigo) {
            try {
                funcFiltroLista = new Function("return " + c.filtroCodigo)()
            } catch (error) {

            }
        }

        let propsAdd = {
            colunas: c.colunas, filtros: c.filtros, custonFormReferente: form,
            editarEmDialog: c.editarEmDialog,
            botoesAntes: c.botoesAntes,
            descricaoFiltroCodigo: c.descricaoFiltroCodigo,
            funcFiltroLista,

        }
        return {
            rota: c.label,
            permissao: c.permissao ? form.permissao + "." + c.permissao : "",
            nomeMenu: c.label,
            ordemMenu: c.label,
            subDe: "",
            component: DinamicCrudCustomConsulta,
            propsAdd
        }
    }
}

export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/ConsultaPersonalisada/index.js